// @ts-nocheck
/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * SUREnet alerts-public API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';
import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';
import type { AlertsFeaturesAlertPolisActiveerPolisAlertDto } from '../model/alertsFeaturesAlertPolisActiveerPolisAlertDto';
import type { AlertsFeaturesAlertPolisCreatePolisAlertVoorOfferteDto } from '../model/alertsFeaturesAlertPolisCreatePolisAlertVoorOfferteDto';
import type { AlertsFeaturesAlertPolisCreatePolisAlertVoorPolisDto } from '../model/alertsFeaturesAlertPolisCreatePolisAlertVoorPolisDto';
import type { AlertsFeaturesAlertPolisUpdatePolisAlertDto } from '../model/alertsFeaturesAlertPolisUpdatePolisAlertDto';
import type { CollectionResultOfAlertsFeaturesAlertAlertVariabelen } from '../model/collectionResultOfAlertsFeaturesAlertAlertVariabelen';
import type { CollectionResultOfAlertsFeaturesAlertPolisGetPolisAlertCountByAdviseurDto } from '../model/collectionResultOfAlertsFeaturesAlertPolisGetPolisAlertCountByAdviseurDto';
import type { CollectionResultOfAlertsFeaturesAlertPolisGetPolisAlertsByOfferteDto } from '../model/collectionResultOfAlertsFeaturesAlertPolisGetPolisAlertsByOfferteDto';
import type { CollectionResultOfAlertsFeaturesAlertPolisGetPolisAlertsByRelatieDto } from '../model/collectionResultOfAlertsFeaturesAlertPolisGetPolisAlertsByRelatieDto';
import type { PolisAlertsCreateForPolisParams } from '../model/polisAlertsCreateForPolisParams';
import type { PolisAlertsGetByRelatieParams } from '../model/polisAlertsGetByRelatieParams';
import type { PolisAlertsGetCountByAdviseurParams } from '../model/polisAlertsGetCountByAdviseurParams';
import type { PolisAlertsMaakEnVerstuurNotificatiesParams } from '../model/polisAlertsMaakEnVerstuurNotificatiesParams';
import type { Result1OfAlertsFeaturesAlertPolisGetPolisAlertsOntvangOptiesDto } from '../model/result1OfAlertsFeaturesAlertPolisGetPolisAlertsOntvangOptiesDto';
import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Alerts.AlertInzien</li></ul>
 * @summary Haalt alerts op die horen bij een offerte of de daaraan gekoppelde polis
 */
export const polisAlertsGetByOfferte = (
  offertenummer: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  offertenummer = unref(offertenummer);

  return customInstance<CollectionResultOfAlertsFeaturesAlertPolisGetPolisAlertsByOfferteDto>(
    { url: `/api/v1/alerts/offerte/${offertenummer}`, method: 'GET', signal },
    options,
  );
};

export const getPolisAlertsGetByOfferteQueryKey = (
  offertenummer: MaybeRef<string | undefined | null>,
) => ['api', 'v1', 'alerts', 'offerte', offertenummer] as const;

export const getPolisAlertsGetByOfferteQueryOptions = <
  TData = Awaited<ReturnType<typeof polisAlertsGetByOfferte>>,
  TError = ErrorType<void>,
>(
  offertenummer: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisAlertsGetByOfferte>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisAlertsGetByOfferteQueryKey(offertenummer);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof polisAlertsGetByOfferte>>> = ({
    signal,
  }) => polisAlertsGetByOfferte(offertenummer, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(offertenummer)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof polisAlertsGetByOfferte>>, TError, TData>;
};

export type PolisAlertsGetByOfferteQueryResult = NonNullable<
  Awaited<ReturnType<typeof polisAlertsGetByOfferte>>
>;
export type PolisAlertsGetByOfferteQueryError = ErrorType<void>;

/**
 * @summary Haalt alerts op die horen bij een offerte of de daaraan gekoppelde polis
 */

export function usePolisAlertsGetByOfferte<
  TData = Awaited<ReturnType<typeof polisAlertsGetByOfferte>>,
  TError = ErrorType<void>,
>(
  offertenummer: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisAlertsGetByOfferte>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPolisAlertsGetByOfferteQueryOptions(offertenummer, options);

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Alerts.AlertAanmaken</li></ul>
 * @summary Maakt een nieuwe alert aan op basis van een offerte
 */
export const polisAlertsCreate = (
  offertenummer: MaybeRef<string | undefined | null>,
  alertsFeaturesAlertPolisCreatePolisAlertVoorOfferteDto: MaybeRef<AlertsFeaturesAlertPolisCreatePolisAlertVoorOfferteDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  offertenummer = unref(offertenummer);
  alertsFeaturesAlertPolisCreatePolisAlertVoorOfferteDto = unref(
    alertsFeaturesAlertPolisCreatePolisAlertVoorOfferteDto,
  );

  return customInstance<void>(
    {
      url: `/api/v1/alerts/offerte/${offertenummer}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: alertsFeaturesAlertPolisCreatePolisAlertVoorOfferteDto,
      signal,
    },
    options,
  );
};

export const getPolisAlertsCreateMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof polisAlertsCreate>>,
    TError,
    {
      offertenummer: string | undefined | null;
      data: AlertsFeaturesAlertPolisCreatePolisAlertVoorOfferteDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof polisAlertsCreate>>,
  TError,
  {
    offertenummer: string | undefined | null;
    data: AlertsFeaturesAlertPolisCreatePolisAlertVoorOfferteDto;
  },
  TContext
> => {
  const mutationKey = ['polisAlertsCreate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof polisAlertsCreate>>,
    {
      offertenummer: string | undefined | null;
      data: AlertsFeaturesAlertPolisCreatePolisAlertVoorOfferteDto;
    }
  > = (props) => {
    const { offertenummer, data } = props ?? {};

    return polisAlertsCreate(offertenummer, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PolisAlertsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof polisAlertsCreate>>
>;
export type PolisAlertsCreateMutationBody = AlertsFeaturesAlertPolisCreatePolisAlertVoorOfferteDto;
export type PolisAlertsCreateMutationError = ErrorType<void>;

/**
 * @summary Maakt een nieuwe alert aan op basis van een offerte
 */
export const usePolisAlertsCreate = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof polisAlertsCreate>>,
    TError,
    {
      offertenummer: string | undefined | null;
      data: AlertsFeaturesAlertPolisCreatePolisAlertVoorOfferteDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationReturnType<
  Awaited<ReturnType<typeof polisAlertsCreate>>,
  TError,
  {
    offertenummer: string | undefined | null;
    data: AlertsFeaturesAlertPolisCreatePolisAlertVoorOfferteDto;
  },
  TContext
> => {
  const mutationOptions = getPolisAlertsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Alerts.AlertInzien</li></ul>
 * @summary Haalt het aantal alerts op die horen bij de opgegeven adviseur
 */
export const polisAlertsGetCountByAdviseur = (
  params?: MaybeRef<PolisAlertsGetCountByAdviseurParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfAlertsFeaturesAlertPolisGetPolisAlertCountByAdviseurDto>(
    { url: `/api/v1/alerts/adviseur`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getPolisAlertsGetCountByAdviseurQueryKey = (
  params?: MaybeRef<PolisAlertsGetCountByAdviseurParams>,
) => ['api', 'v1', 'alerts', 'adviseur', ...(params ? [params] : [])] as const;

export const getPolisAlertsGetCountByAdviseurQueryOptions = <
  TData = Awaited<ReturnType<typeof polisAlertsGetCountByAdviseur>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<PolisAlertsGetCountByAdviseurParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisAlertsGetCountByAdviseur>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisAlertsGetCountByAdviseurQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof polisAlertsGetCountByAdviseur>>> = ({
    signal,
  }) => polisAlertsGetCountByAdviseur(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof polisAlertsGetCountByAdviseur>>,
    TError,
    TData
  >;
};

export type PolisAlertsGetCountByAdviseurQueryResult = NonNullable<
  Awaited<ReturnType<typeof polisAlertsGetCountByAdviseur>>
>;
export type PolisAlertsGetCountByAdviseurQueryError = ErrorType<void>;

/**
 * @summary Haalt het aantal alerts op die horen bij de opgegeven adviseur
 */

export function usePolisAlertsGetCountByAdviseur<
  TData = Awaited<ReturnType<typeof polisAlertsGetCountByAdviseur>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRef<PolisAlertsGetCountByAdviseurParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisAlertsGetCountByAdviseur>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPolisAlertsGetCountByAdviseurQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Alerts.AlertInzien</li></ul>
 * @summary Haalt alerts op die horen bij de opgegeven relatie en adviseur
 */
export const polisAlertsGetByRelatie = (
  relatienummer: MaybeRef<number | undefined | null>,
  params?: MaybeRef<PolisAlertsGetByRelatieParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatienummer = unref(relatienummer);
  params = unref(params);

  return customInstance<CollectionResultOfAlertsFeaturesAlertPolisGetPolisAlertsByRelatieDto>(
    {
      url: `/api/v1/alerts/relatie/${relatienummer}`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPolisAlertsGetByRelatieQueryKey = (
  relatienummer: MaybeRef<number | undefined | null>,
  params?: MaybeRef<PolisAlertsGetByRelatieParams>,
) => ['api', 'v1', 'alerts', 'relatie', relatienummer, ...(params ? [params] : [])] as const;

export const getPolisAlertsGetByRelatieQueryOptions = <
  TData = Awaited<ReturnType<typeof polisAlertsGetByRelatie>>,
  TError = ErrorType<void>,
>(
  relatienummer: MaybeRef<number | undefined | null>,
  params?: MaybeRef<PolisAlertsGetByRelatieParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisAlertsGetByRelatie>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisAlertsGetByRelatieQueryKey(relatienummer, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof polisAlertsGetByRelatie>>> = ({
    signal,
  }) => polisAlertsGetByRelatie(relatienummer, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(relatienummer)),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof polisAlertsGetByRelatie>>, TError, TData>;
};

export type PolisAlertsGetByRelatieQueryResult = NonNullable<
  Awaited<ReturnType<typeof polisAlertsGetByRelatie>>
>;
export type PolisAlertsGetByRelatieQueryError = ErrorType<void>;

/**
 * @summary Haalt alerts op die horen bij de opgegeven relatie en adviseur
 */

export function usePolisAlertsGetByRelatie<
  TData = Awaited<ReturnType<typeof polisAlertsGetByRelatie>>,
  TError = ErrorType<void>,
>(
  relatienummer: MaybeRef<number | undefined | null>,
  params?: MaybeRef<PolisAlertsGetByRelatieParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof polisAlertsGetByRelatie>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPolisAlertsGetByRelatieQueryOptions(relatienummer, params, options);

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Alerts.AlertInzien</li></ul>
 * @summary Haal ontvanger opties voor de alerts op
 */
export const polisAlertsGetOntvangerOptiesByOfferte = (
  offertenummer: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  offertenummer = unref(offertenummer);

  return customInstance<Result1OfAlertsFeaturesAlertPolisGetPolisAlertsOntvangOptiesDto>(
    { url: `/api/v1/alerts/offerte/${offertenummer}/ontvangers`, method: 'GET', signal },
    options,
  );
};

export const getPolisAlertsGetOntvangerOptiesByOfferteQueryKey = (
  offertenummer: MaybeRef<string | undefined | null>,
) => ['api', 'v1', 'alerts', 'offerte', offertenummer, 'ontvangers'] as const;

export const getPolisAlertsGetOntvangerOptiesByOfferteQueryOptions = <
  TData = Awaited<ReturnType<typeof polisAlertsGetOntvangerOptiesByOfferte>>,
  TError = ErrorType<void>,
>(
  offertenummer: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof polisAlertsGetOntvangerOptiesByOfferte>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisAlertsGetOntvangerOptiesByOfferteQueryKey(offertenummer);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof polisAlertsGetOntvangerOptiesByOfferte>>
  > = ({ signal }) => polisAlertsGetOntvangerOptiesByOfferte(offertenummer, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(offertenummer)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof polisAlertsGetOntvangerOptiesByOfferte>>,
    TError,
    TData
  >;
};

export type PolisAlertsGetOntvangerOptiesByOfferteQueryResult = NonNullable<
  Awaited<ReturnType<typeof polisAlertsGetOntvangerOptiesByOfferte>>
>;
export type PolisAlertsGetOntvangerOptiesByOfferteQueryError = ErrorType<void>;

/**
 * @summary Haal ontvanger opties voor de alerts op
 */

export function usePolisAlertsGetOntvangerOptiesByOfferte<
  TData = Awaited<ReturnType<typeof polisAlertsGetOntvangerOptiesByOfferte>>,
  TError = ErrorType<void>,
>(
  offertenummer: MaybeRef<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof polisAlertsGetOntvangerOptiesByOfferte>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPolisAlertsGetOntvangerOptiesByOfferteQueryOptions(
    offertenummer,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Alerts.AlertAanmaken</li></ul>
 * @summary Maakt een nieuwe alert aan op basis van een offerte
 */
export const polisAlertsCreateForPolis = (
  alertsFeaturesAlertPolisCreatePolisAlertVoorPolisDto: MaybeRef<AlertsFeaturesAlertPolisCreatePolisAlertVoorPolisDto>,
  params?: MaybeRef<PolisAlertsCreateForPolisParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  alertsFeaturesAlertPolisCreatePolisAlertVoorPolisDto = unref(
    alertsFeaturesAlertPolisCreatePolisAlertVoorPolisDto,
  );
  params = unref(params);

  return customInstance<void>(
    {
      url: `/api/v1/alerts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: alertsFeaturesAlertPolisCreatePolisAlertVoorPolisDto,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPolisAlertsCreateForPolisMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof polisAlertsCreateForPolis>>,
    TError,
    {
      data: AlertsFeaturesAlertPolisCreatePolisAlertVoorPolisDto;
      params?: PolisAlertsCreateForPolisParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof polisAlertsCreateForPolis>>,
  TError,
  {
    data: AlertsFeaturesAlertPolisCreatePolisAlertVoorPolisDto;
    params?: PolisAlertsCreateForPolisParams;
  },
  TContext
> => {
  const mutationKey = ['polisAlertsCreateForPolis'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof polisAlertsCreateForPolis>>,
    {
      data: AlertsFeaturesAlertPolisCreatePolisAlertVoorPolisDto;
      params?: PolisAlertsCreateForPolisParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return polisAlertsCreateForPolis(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PolisAlertsCreateForPolisMutationResult = NonNullable<
  Awaited<ReturnType<typeof polisAlertsCreateForPolis>>
>;
export type PolisAlertsCreateForPolisMutationBody =
  AlertsFeaturesAlertPolisCreatePolisAlertVoorPolisDto;
export type PolisAlertsCreateForPolisMutationError = ErrorType<void>;

/**
 * @summary Maakt een nieuwe alert aan op basis van een offerte
 */
export const usePolisAlertsCreateForPolis = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof polisAlertsCreateForPolis>>,
    TError,
    {
      data: AlertsFeaturesAlertPolisCreatePolisAlertVoorPolisDto;
      params?: PolisAlertsCreateForPolisParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationReturnType<
  Awaited<ReturnType<typeof polisAlertsCreateForPolis>>,
  TError,
  {
    data: AlertsFeaturesAlertPolisCreatePolisAlertVoorPolisDto;
    params?: PolisAlertsCreateForPolisParams;
  },
  TContext
> => {
  const mutationOptions = getPolisAlertsCreateForPolisMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Alerts.AlertBijwerken</li></ul>
 * @summary Werkt een alert bij
 */
export const polisAlertsUpdate = (
  polisAlertId: MaybeRef<string | undefined | null>,
  alertsFeaturesAlertPolisUpdatePolisAlertDto: MaybeRef<AlertsFeaturesAlertPolisUpdatePolisAlertDto>,
  options?: SecondParameter<typeof customInstance>,
) => {
  polisAlertId = unref(polisAlertId);
  alertsFeaturesAlertPolisUpdatePolisAlertDto = unref(alertsFeaturesAlertPolisUpdatePolisAlertDto);

  return customInstance<void>(
    {
      url: `/api/v1/alerts/${polisAlertId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: alertsFeaturesAlertPolisUpdatePolisAlertDto,
    },
    options,
  );
};

export const getPolisAlertsUpdateMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof polisAlertsUpdate>>,
    TError,
    { polisAlertId: string | undefined | null; data: AlertsFeaturesAlertPolisUpdatePolisAlertDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof polisAlertsUpdate>>,
  TError,
  { polisAlertId: string | undefined | null; data: AlertsFeaturesAlertPolisUpdatePolisAlertDto },
  TContext
> => {
  const mutationKey = ['polisAlertsUpdate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof polisAlertsUpdate>>,
    { polisAlertId: string | undefined | null; data: AlertsFeaturesAlertPolisUpdatePolisAlertDto }
  > = (props) => {
    const { polisAlertId, data } = props ?? {};

    return polisAlertsUpdate(polisAlertId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PolisAlertsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof polisAlertsUpdate>>
>;
export type PolisAlertsUpdateMutationBody = AlertsFeaturesAlertPolisUpdatePolisAlertDto;
export type PolisAlertsUpdateMutationError = ErrorType<void>;

/**
 * @summary Werkt een alert bij
 */
export const usePolisAlertsUpdate = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof polisAlertsUpdate>>,
    TError,
    { polisAlertId: string | undefined | null; data: AlertsFeaturesAlertPolisUpdatePolisAlertDto },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationReturnType<
  Awaited<ReturnType<typeof polisAlertsUpdate>>,
  TError,
  { polisAlertId: string | undefined | null; data: AlertsFeaturesAlertPolisUpdatePolisAlertDto },
  TContext
> => {
  const mutationOptions = getPolisAlertsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Alerts.AlertAanmaken</li></ul>
 * @summary Verwijdert een alert
 */
export const polisAlertsDelete = (
  polisAlertId: MaybeRef<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
) => {
  polisAlertId = unref(polisAlertId);

  return customInstance<void>({ url: `/api/v1/alerts/${polisAlertId}`, method: 'DELETE' }, options);
};

export const getPolisAlertsDeleteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof polisAlertsDelete>>,
    TError,
    { polisAlertId: string | undefined | null },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof polisAlertsDelete>>,
  TError,
  { polisAlertId: string | undefined | null },
  TContext
> => {
  const mutationKey = ['polisAlertsDelete'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof polisAlertsDelete>>,
    { polisAlertId: string | undefined | null }
  > = (props) => {
    const { polisAlertId } = props ?? {};

    return polisAlertsDelete(polisAlertId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PolisAlertsDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof polisAlertsDelete>>
>;

export type PolisAlertsDeleteMutationError = ErrorType<void>;

/**
 * @summary Verwijdert een alert
 */
export const usePolisAlertsDelete = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof polisAlertsDelete>>,
    TError,
    { polisAlertId: string | undefined | null },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationReturnType<
  Awaited<ReturnType<typeof polisAlertsDelete>>,
  TError,
  { polisAlertId: string | undefined | null },
  TContext
> => {
  const mutationOptions = getPolisAlertsDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Activeert de alerts voor een offerte
 */
export const polisAlertsActiveer = (
  offertenummer: MaybeRef<string | undefined | null>,
  alertsFeaturesAlertPolisActiveerPolisAlertDto: MaybeRef<AlertsFeaturesAlertPolisActiveerPolisAlertDto>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  offertenummer = unref(offertenummer);
  alertsFeaturesAlertPolisActiveerPolisAlertDto = unref(
    alertsFeaturesAlertPolisActiveerPolisAlertDto,
  );

  return customInstance<void>(
    {
      url: `/api/v1/alerts/offerte/${offertenummer}/activeer`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json-patch+json' },
      data: alertsFeaturesAlertPolisActiveerPolisAlertDto,
      signal,
    },
    options,
  );
};

export const getPolisAlertsActiveerMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof polisAlertsActiveer>>,
    TError,
    {
      offertenummer: string | undefined | null;
      data: AlertsFeaturesAlertPolisActiveerPolisAlertDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof polisAlertsActiveer>>,
  TError,
  { offertenummer: string | undefined | null; data: AlertsFeaturesAlertPolisActiveerPolisAlertDto },
  TContext
> => {
  const mutationKey = ['polisAlertsActiveer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof polisAlertsActiveer>>,
    {
      offertenummer: string | undefined | null;
      data: AlertsFeaturesAlertPolisActiveerPolisAlertDto;
    }
  > = (props) => {
    const { offertenummer, data } = props ?? {};

    return polisAlertsActiveer(offertenummer, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PolisAlertsActiveerMutationResult = NonNullable<
  Awaited<ReturnType<typeof polisAlertsActiveer>>
>;
export type PolisAlertsActiveerMutationBody = AlertsFeaturesAlertPolisActiveerPolisAlertDto;
export type PolisAlertsActiveerMutationError = ErrorType<void>;

/**
 * @summary Activeert de alerts voor een offerte
 */
export const usePolisAlertsActiveer = <TError = ErrorType<void>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof polisAlertsActiveer>>,
    TError,
    {
      offertenummer: string | undefined | null;
      data: AlertsFeaturesAlertPolisActiveerPolisAlertDto;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationReturnType<
  Awaited<ReturnType<typeof polisAlertsActiveer>>,
  TError,
  { offertenummer: string | undefined | null; data: AlertsFeaturesAlertPolisActiveerPolisAlertDto },
  TContext
> => {
  const mutationOptions = getPolisAlertsActiveerMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Alerts.AlertAanmaken</li></ul>
 * @summary Maakt en verstuurd notificaties voor de opgegeven datum
 */
export const polisAlertsMaakEnVerstuurNotificaties = (
  params?: MaybeRef<PolisAlertsMaakEnVerstuurNotificatiesParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<void>(
    {
      url: `/api/v1/alerts/maakEnVerstuurNotificaties`,
      method: 'POST',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPolisAlertsMaakEnVerstuurNotificatiesMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof polisAlertsMaakEnVerstuurNotificaties>>,
    TError,
    { params?: PolisAlertsMaakEnVerstuurNotificatiesParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof polisAlertsMaakEnVerstuurNotificaties>>,
  TError,
  { params?: PolisAlertsMaakEnVerstuurNotificatiesParams },
  TContext
> => {
  const mutationKey = ['polisAlertsMaakEnVerstuurNotificaties'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof polisAlertsMaakEnVerstuurNotificaties>>,
    { params?: PolisAlertsMaakEnVerstuurNotificatiesParams }
  > = (props) => {
    const { params } = props ?? {};

    return polisAlertsMaakEnVerstuurNotificaties(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PolisAlertsMaakEnVerstuurNotificatiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof polisAlertsMaakEnVerstuurNotificaties>>
>;

export type PolisAlertsMaakEnVerstuurNotificatiesMutationError = ErrorType<void>;

/**
 * @summary Maakt en verstuurd notificaties voor de opgegeven datum
 */
export const usePolisAlertsMaakEnVerstuurNotificaties = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof polisAlertsMaakEnVerstuurNotificaties>>,
    TError,
    { params?: PolisAlertsMaakEnVerstuurNotificatiesParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationReturnType<
  Awaited<ReturnType<typeof polisAlertsMaakEnVerstuurNotificaties>>,
  TError,
  { params?: PolisAlertsMaakEnVerstuurNotificatiesParams },
  TContext
> => {
  const mutationOptions = getPolisAlertsMaakEnVerstuurNotificatiesMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Alerts.AlertInzien</li></ul>
 * @summary Haalt alle alertvariabelen op die bij een alert kunnen worden ingesteld.
 */
export const polisAlertsGetAlertvariabelen = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) =>
  customInstance<CollectionResultOfAlertsFeaturesAlertAlertVariabelen>(
    { url: `/api/v1/alerts/alertVariabelen`, method: 'GET', signal },
    options,
  );

export const getPolisAlertsGetAlertvariabelenQueryKey = () =>
  ['api', 'v1', 'alerts', 'alertVariabelen'] as const;

export const getPolisAlertsGetAlertvariabelenQueryOptions = <
  TData = Awaited<ReturnType<typeof polisAlertsGetAlertvariabelen>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof polisAlertsGetAlertvariabelen>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getPolisAlertsGetAlertvariabelenQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof polisAlertsGetAlertvariabelen>>> = ({
    signal,
  }) => polisAlertsGetAlertvariabelen(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof polisAlertsGetAlertvariabelen>>,
    TError,
    TData
  >;
};

export type PolisAlertsGetAlertvariabelenQueryResult = NonNullable<
  Awaited<ReturnType<typeof polisAlertsGetAlertvariabelen>>
>;
export type PolisAlertsGetAlertvariabelenQueryError = ErrorType<void>;

/**
 * @summary Haalt alle alertvariabelen op die bij een alert kunnen worden ingesteld.
 */

export function usePolisAlertsGetAlertvariabelen<
  TData = Awaited<ReturnType<typeof polisAlertsGetAlertvariabelen>>,
  TError = ErrorType<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof polisAlertsGetAlertvariabelen>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPolisAlertsGetAlertvariabelenQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData>;

  return query;
}
